import { useParams } from 'react-router-dom'
import React from 'react'
import { Text } from '@common/ui'
import { com } from '@eidu/web'
import ImportEntitiesPage from '../ImportEntitiesPage'
import entityTypeIdFromString = com.eidu.entity.type.entityTypeIdFromString

const ImportPageRoute = () => {
  const params = useParams()

  if (params.entityTypeId) {
    return <ImportEntitiesPage entityTypeId={entityTypeIdFromString(params.entityTypeId)} />
  }

  return <Text p="lg">Unknown entity type</Text>
}

export default ImportPageRoute
